import { render, staticRenderFns } from "./EmailNotReceived.vue?vue&type=template&id=f319fb38&scoped=true&"
import script from "./EmailNotReceived.vue?vue&type=script&lang=js&"
export * from "./EmailNotReceived.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotReceived.vue?vue&type=style&index=0&id=f319fb38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f319fb38",
  null
  
)

export default component.exports